module.exports = __webpack_public_path__ + "img/xmasParty7.53bc582e.jpg";